import { IPlaidAccountBalanceHistoryResponse } from '@common/interfaces/plaid'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

interface IPlaidItemListItem {
  id: string
  institutionId: string
  institutionName: string
  status: string
  lastSyncedAt: string | null
  lastSyncAttemptAt: string | null
  initialSyncCompletedAt: string | null
  errorCode: string | null
  errorMessage: string | null
  linkSource: string
  ddClientInfoId: string | null
  accountsCount: number
  createdAt: string
}

interface IPlaidAccountListItem {
  id: string
  plaidAccountId: string
  accountName: string | null
  officialName: string | null
  mask: string | null
  type: string | null
  subtype: string | null
  currentBalance: string | null
  availableBalance: string | null
  isoCurrencyCode: string | null
  bankAccountInfoId: string | null
  isPromoted: boolean
  bankAccountInfo: { id: string; bankName: string; accountNumberLast4: string | null } | null
}

export interface IAccountsResponse {
  item: { id: string; institutionName: string; status: string; clientName: string } | null
  accounts: IPlaidAccountListItem[]
}

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.REMOVE_REQUEST:
      case actions.MANUAL_SYNC_REQUEST:
        return [...state, action.type]
      case actions.REMOVE_SUCCESS:
      case actions.REMOVE_FAILURE:
      case actions.MANUAL_SYNC_SUCCESS:
      case actions.MANUAL_SYNC_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  items: createLoadingDataReducer<{ data: IPlaidItemListItem[] }>([actions.LIST_ITEMS_REQUEST]),
  accounts: createLoadingDataReducer<{ data: IAccountsResponse }>([actions.LIST_ACCOUNTS_REQUEST]),
  balanceHistory: createLoadingDataReducer<{ data: IPlaidAccountBalanceHistoryResponse }>([
    actions.LIST_BALANCE_HISTORY_REQUEST,
  ]),
})
